var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlantPlain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 3 4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.608,1.299l1.153,0c0.07,0 0.127,0.056 0.127,0.127l0,1.007c0,0.028 -0.01,0.056 -0.028,0.079l-0.576,0.724c-0.044,0.055 -0.124,0.064 -0.178,0.02c-0.008,-0.006 -0.015,-0.012 -0.021,-0.02l-0.576,-0.724c-0.018,-0.023 -0.028,-0.051 -0.028,-0.079l0,-1.007c0,-0.071 0.057,-0.127 0.127,-0.127Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.608,0.12l1.153,0c0.07,0 0.127,0.057 0.127,0.127l0,0.483c0,0.07 -0.057,0.127 -0.127,0.127l-1.153,0c-0.07,0 -0.127,-0.057 -0.127,-0.127l0,-0.483c0,-0.07 0.057,-0.127 0.127,-0.127Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.123,3.729l-0.32,-1.172",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "0.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.559,2.563l-0.319,1.172",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "0.17px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantPlain);
export default __webpack_public_path__ + "static/media/plant-plain.d90e9523a66bb5b23f6ae08673d458e6.svg";
export { ForwardRef as ReactComponent };